import _createClass from "@babel/runtime/helpers/esm/createClass";

/* eslint no-unused-expressions:0 */
import { warn } from '../console';

var DefaultAdapter = /*#__PURE__*/function () {
  function DefaultAdapter() {}

  var _proto = DefaultAdapter.prototype;

  _proto.translate = function translate(key, values) {
    warn(undefined, key, values);
    return key;
  };

  _createClass(DefaultAdapter, [{
    key: "instance",
    get: function get() {
      warn();
    }
  }, {
    key: "locale",
    set: function set(locale) {// warn('DefaultAdapter#setLocale', locale);
    }
  }, {
    key: "translations",
    set: function set(translations) {// warn('DefaultAdapter#setTranslations', translations);
    }
  }]);

  return DefaultAdapter;
}();

export { DefaultAdapter as default };